import { useMemo } from "react";

import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";

import { buildEmailPreviewSrcDoc } from "utils/message-templates.util";

type EmailPreviewIframeProps = {
  html?: string | null;
  text?: string | null;
  title?: string;
  sx?: SxProps<Theme>;
};

export default function EmailPreviewIframe({
  html,
  text,
  title = "Email preview",
  sx
}: EmailPreviewIframeProps) {
  const srcDoc = useMemo(
    () => buildEmailPreviewSrcDoc(html, text),
    [html, text]
  );

  return (
    <Box
      component="iframe"
      title={title}
      srcDoc={srcDoc}
      // No allow-scripts: JS is blocked intentionally. HTML is passed unsanitized
      // but isolated by the sandbox. Do NOT add allow-scripts here.
      sandbox="allow-same-origin"
      loading="lazy"
      sx={{
        border: "none",
        width: "100%",
        minHeight: 400,
        display: "block",
        ...sx
      }}
    />
  );
}
